import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { RequestSectionHeaderTitle } from "@/components/common/section-components/requests/RequestSectionHeaderTitle";
import { TransferRequestDetailLegend } from "@/components/common/section-components/requests/transfer/TransferRequestDetailLegend";
import { TransferRequestMessageList } from "@/components/common/section-components/requests/transfer/TransferRequestMessageList";
import { TransferRequestAmountAndActions } from "@/components/common/section-components/requests/transfer/TransferRequestAmountAndActions";
import { TransferRequestMainDataCard } from "@/components/common/section-components/card/TransferRequestMainDataCard";
import { AppRoutes } from "@/constants/routes";
import { AppColors } from "@/styles/colors";
import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRoles } from "@/hooks/useRoles";
import { ExternalTransferDetail } from "../schema/external-transfer.schema";
import { fetchExternalTransferDetailHandler } from "../schema/handler-functions";

export const ExternalTransferDetailPage = () => {
  const [isActive, setIsActive] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [request, setRequest] = useState<ExternalTransferDetail | null>(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const { fetchPermissions } = useRoles();

  useEffect(() => {
    setIsActive(true);
  }, []);

  useEffect(() => {
    if (isActive && id) {
      fetchExternalTransferDetailHandler({
        id,
        setLoadingRequest,
        setRequest,
        navigate,
        fetchPermissions,
      });
    }
  }, [isActive, id]);

  const handleBack = () => {
    navigate(AppRoutes.EXTERNAL_TRANSFER_REQUESTS);
  };

  return (
    <Flex flexDir="column" paddingTop="20px" gap="12px">
      <SectionHeader
        title={
          <RequestSectionHeaderTitle
            request={request}
            type="Transferencia externa"
          />
        }
        onBack={handleBack}
        backButton
        loading={loadingRequest}
      />

      {!loadingRequest && (
        <>
          <TransferRequestAmountAndActions request={request} />

          <TransferRequestMainDataCard request={request} />

          <Flex
            flexDir="column"
            padding="12px"
            height="100%"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            borderRadius="12px"
            gap="25px"
          >
            <TransferRequestDetailLegend />

            <TransferRequestMessageList request={request} />
          </Flex>
        </>
      )}
    </Flex>
  );
};
